import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SprekerService } from '../spreker.service';

@Component({
  selector: 'app-speakers',
  templateUrl: './speakers.component.html',
  styleUrls: ['./speakers.component.css']
})
export class SpeakersComponent implements OnInit {
  sprekers: Array<object>;

  constructor(public router: Router, private sprekerService: SprekerService) {
    this.sprekers = sprekerService.getSprekers();
    console.log(this.sprekers);
   }

  ngOnInit(): void {
  }

}
